import axiosInstance from '../axiosInstance.js'

export default {
  createStage({ token, newStagePayload }) {
    newStagePayload.systemName = newStagePayload.slug
    return axiosInstance.post('/stages', JSON.stringify(newStagePayload), {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  },

  getAuthArtistStageConfigs(token) {
    return axiosInstance.get('/memberships', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
  }
}
